import { render } from "./ModalTrigger.vue?vue&type=template&id=3bcd49bc&scoped=true&ts=true"
import script from "./ModalTrigger.vue?vue&type=script&lang=ts"
export * from "./ModalTrigger.vue?vue&type=script&lang=ts"

import "./ModalTrigger.vue?vue&type=style&index=0&id=3bcd49bc&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bcd49bc"]])

export default __exports__